import React from "react";
import { Link } from "react-router-dom";
import PatternOverlay from "@/components/PatternOverlay";
import NavLetters from "@/components/NavLetters";

const linkCls =
  "nav-lift-wrap inline-block text-muted-foreground hover:text-primary transition-colors";

export default function Footer() {
  return (
    <footer className="pattern-bg border-t border-border bg-background" data-testid="site-footer">
      <PatternOverlay opacity={0.09} size={520} />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img
            src="/logo-aexents.png"
            alt="æxènts London"
            className="h-16 w-auto"
          />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-muted-foreground">
            A modern perfumery composing rare essences into cinematic
            signatures. Handcrafted in small batches, shipped worldwide.
          </p>
          <form className="mt-8 flex gap-3 max-w-md" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Enter your email"
              data-testid="footer-newsletter-input"
              className="flex-1 bg-transparent border-b border-border px-0 py-3 text-foreground focus:outline-none focus:border-primary text-sm placeholder:text-muted-foreground"
            />
            <button
              data-testid="footer-newsletter-submit"
              className="border border-border hover:border-primary hover:text-primary text-xs uppercase tracking-[0.22em] px-6 py-3 transition-all"
            >
              Subscribe
            </button>
          </form>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.28em] text-primary mb-5">Shop</div>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/shop" className={linkCls}>
                <NavLetters text="All Fragrances" />
              </Link>
            </li>
            <li>
              <Link to="/shop?category=her" className={linkCls}>
                <NavLetters text="For Her" />
              </Link>
            </li>
            <li>
              <Link to="/shop?category=him" className={linkCls}>
                <NavLetters text="For Him" />
              </Link>
            </li>
            <li>
              <Link to="/shop?category=unisex" className={linkCls}>
                <NavLetters text="Unisex" />
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.28em] text-primary mb-5">House</div>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/our-story" className={linkCls}>
                <NavLetters text="Our Story" />
              </Link>
            </li>
            <li>
              <Link to="/journal" className={linkCls}>
                <NavLetters text="Journal" />
              </Link>
            </li>
            <li>
              <Link to="/shipping-returns" className={linkCls}>
                <NavLetters text="Shipping & Returns" />
              </Link>
            </li>
            <li>
              <Link to="/contact" className={linkCls}>
                <NavLetters text="Contact" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-muted-foreground tracking-[0.28em] uppercase">
          <div>© {new Date().getFullYear()} æxènts London</div>
          <div>aexents.com</div>
        </div>
      </div>
    </footer>
  );
}
